import React from 'react';
interface CreditNoteTotalsProps {
  subtotal: number;
  tax: number;
  totalCredit: number;
}
export function CreditNoteTotals({
  subtotal,
  tax,
  totalCredit
}: CreditNoteTotalsProps) {
  const formatCurrency = (amount: number) => {
    return `$${amount.toFixed(2)}`;
  };
  return <div className="flex justify-end mb-8" data-id="element-245">
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-6 min-w-[320px] shadow-sm" data-id="element-246">
        <div className="space-y-3" data-id="element-247">
          <div className="flex justify-between items-center" data-id="element-248">
            <span className="text-sm font-medium text-neutral-600" data-id="element-249">
              Subtotal:
            </span>
            <span className="text-sm text-neutral-900 tabular-nums" data-id="element-250">
              {formatCurrency(subtotal)}
            </span>
          </div>

          <div className="flex justify-between items-center" data-id="element-251">
            <span className="text-sm font-medium text-neutral-600" data-id="element-252">GST:</span>
            <span className="text-sm text-neutral-900 tabular-nums" data-id="element-253">
              {formatCurrency(tax)}
            </span>
          </div>

          <div className="h-px bg-neutral-300" data-id="element-254" />

          <div className="flex justify-between items-center bg-green-50 border border-green-200 -mx-6 px-6 py-3 rounded" data-id="element-255">
            <span className="text-base font-bold text-neutral-900" data-id="element-256">
              Total Credit:
            </span>
            <span className="text-lg font-bold text-green-700 tabular-nums" data-id="element-257">
              {formatCurrency(totalCredit)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}